import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FeUtil } from '../../../hezky-routes';

@Component({
  selector: 'app-asset-cards',
  templateUrl: './asset-cards.component.html',
})
export class AssetCardsComponent implements OnChanges {
  @Input('data') cardData: any;
  isTemperature: boolean = false;
  isPressure: boolean = false;

  constructor(protected feUtil: FeUtil) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['cardData']) {
      this.cardData = changes['cardData'].currentValue;
      let capabilities = (this.cardData?.capabilities || []).map((cap: any) => cap?.toLowerCase());
      this.isTemperature = capabilities.includes('temperature');
      this.isPressure = capabilities.includes('pressure');
    }
  }
}
